/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Draftemail_Cancelschedule3Inputs */

const en_coinvestments_draftemail_cancelschedule3 = /** @type {(inputs: Coinvestments_Draftemail_Cancelschedule3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel schedule`)
};

/**
* | output |
* | --- |
* | "Cancel schedule" |
*
* @param {Coinvestments_Draftemail_Cancelschedule3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_draftemail_cancelschedule3 = /** @type {((inputs?: Coinvestments_Draftemail_Cancelschedule3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Draftemail_Cancelschedule3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_draftemail_cancelschedule3(inputs)
});
export { coinvestments_draftemail_cancelschedule3 as "coInvestments_draftEmail_cancelSchedule" }